module.exports = __webpack_public_path__ + "img/diapositiva-5-4.8955ce9d.png";